import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetExamsTypesLocation,
	GetExamsTypesLocationModel,
	GetExamsTypesLocationParams,
} from 'domain/usecases';

export class RemoteGetExamsTypesLocation implements GetExamsTypesLocation {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsTypesLocationModel>,
	) {}

	async get({
		signal,
		...params
	}: GetExamsTypesLocationParams): Promise<GetExamsTypesLocationModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
